export default "__VITE_ASSET__D8VpD4c$__"